import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { resetUserPassword } from '../../data/store/user/userActions';
import { confirmPassRules, passwordRules } from '../../helpers/validation';
import { useHistory } from 'react-router';
import { Form, Button, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import pic from '../../assets/loginpage-img-light.png';
import titleLogo from '../../assets/lt_logo.png';
import titleLogo_dark from '../../assets/lt_logo_dark.png';

import './style.scss';
import CustomPasswordInput from '../CustomPasswordInput/CustomPasswordInput';
import ThemeTopSwitcher from '../ThemeTopSwitcher/ThemeTopSwitcher';

const ResetPassword = ({ theme, setTheme }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const [form] = Form.useForm();
  const [resetPasswordCode, setResetPasswordCode] = useState('');
  const [isValid, setIsValid] = useState(false);

  const getCode = useCallback(() => {
    const index = history.location.search.split('').indexOf('=') + 1;
    setResetPasswordCode(history.location.search.slice(index));
  }, [history]);

  useEffect(() => {
    getCode();
  }, [history]);

  const handleValueChange = async () => {
    const allValues = await form.getFieldsValue();
    const { password, passwordConfirm } = allValues;
    if (password?.length > 7 && passwordConfirm?.length > 7) {
      try {
        await form.validateFields();
        setIsValid(true);
      } catch (errorInfo) {
        console.log('🚀 ~ handleValueChange ~ errorInfo:', errorInfo);
        setIsValid(false);
      }
    } else {
      setIsValid(false);
    }
  };

  const handleThemeToggler = () => {
    const newTheme = theme === 'dark-theme' ? 'light-theme' : 'dark-theme';
    setTheme(newTheme);
  };

  const onSubmit = useCallback(
    (fields) => {
      const { password } = fields;
      dispatch(resetUserPassword({ password, resetPasswordCode, history }));
    },
    [dispatch, resetPasswordCode],
  );

  return (
    <div className="login-wrapper">
      <div className="theme-switcher-wrapper">
        <ThemeTopSwitcher
          text={['DARK', 'LIGHT']}
          switcher={theme === 'dark-theme' ? 0 : 1}
          handleClick={handleThemeToggler}
        />
      </div>
      <div className="login-picture">
        <img src={pic} alt="login-picture" />
      </div>
      <div className="login-form">
        <div className="login-form-title">
          <img
            src={theme !== 'dark' ? titleLogo : titleLogo_dark}
            alt="title logo"
          />
        </div>
        <Form
          form={form}
          name="reset"
          layout="vertical"
          onFinish={onSubmit}
          className="reset-pass-form"
        >
          <h2 className="pass-setup-title">{t('YOU_NEW_PASSWORD')}</h2>

          <div className="sign-up-wrapper reset-pass-input">
            <Form.Item
              className="client custom-required"
              label={t('PASSWORD')}
              name="password"
              rules={passwordRules}
            >
              <CustomPasswordInput
                placeholder={t('PASSWORD')}
                className="client login-input custom-input"
                autoComplete="new-password"
                onChange={handleValueChange}
              />
            </Form.Item>

            <Form.Item
              className="client custom-required"
              label={t('CONFIRM_PASSWORD')}
              name="passwordConfirm"
              dependencies={['password']}
              rules={confirmPassRules}
            >
              <CustomPasswordInput
                placeholder={t('CONFIRM_PASSWORD')}
                className="client login-input custom-input"
                autoComplete="new-password"
                onChange={handleValueChange}
              />
            </Form.Item>
          </div>

          <Row className="login-submit-btn-wrapper">
            <Button disabled={!isValid} block onClick={() => form.submit()}>
              {t('SET_UP_PASSWORD')}
            </Button>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;

ResetPassword.propTypes = {
  theme: PropTypes.string,
  history: PropTypes.object,
  setTheme: PropTypes.func,
};
